<template>
  <q-page class="q-px-md">
    <div v-for="audit in audits" :key="audit.id">
      <div class="row q-py-md" @click="openAudit(audit)">
        <div class="col-xs-2 col-sm-3 col-md-4 col-lg-5">
          <q-btn
            round
            color="primary"
            size="15px"
            :key="'btn' + audit.id"
            class="float-right"
          >
            <img
              :src="
                auditCategory(audit).img
                  ? 'data:' + auditCategory(audit).img
                  : audit.checklist.category.img
              "
              style="max-height: 25px"
            />
          </q-btn>
        </div>
        <div class="col-xs-10 col-sm-9 col-md-8 col-lg-7 q-pl-sm">
          <span class="uppercase">{{ audit.checklist.name }}</span>
          <span class="q-caption" v-if="audit.dueAt">
            <br /><i
              >{{ $t('report.before_date') }}
              {{ $helpers.stringToDate(audit.dueAt) }}</i
            >
          </span>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      audits: [],
      callbackLocation: null
    }
  },
  mounted() {
    if ('location' in this.$route.query) {
      this.callbackLocation = JSON.parse(this.$route.query.location)
      this.$store
        .dispatch('audits/loadAuditsInOtherScopes', this.callbackLocation)
        .then(() => {
          const newPath = `${this.$route.path}?tab=other`
          this.$router.replace(newPath)
          this.setAudits()
        })
      return
    }
    this.setAudits()
  },
  computed: {
    ...mapGetters({
      categories: 'company/categories',
      allAudits: 'audits/all',
      auditsInOtherScopes: 'audits/auditsInOtherScopes'
    })
  },
  methods: {
    async reducedAudits(placeId) {
      const pendingAudits = (
        await this.$DB.tmpReports().find({
          selector: {
            status: {
              $in: ['IN_PROGRESS', 'PENDING', 'DONE']
            }
          }
        })
      ).docs.map((r) => r.audit.id)
      const placeAudits = (
        await this.$patrimoine.auditsCollection().find({
          selector: {
            id: {
              $in: this.allAudits,
              $nin: pendingAudits
            },
            'place.id': {
              $eq: parseInt(placeId)
            }
          }
        })
      ).docs
      return placeAudits
    },
    async setAudits() {
      if (this.$route.query.tab !== 'myScope') {
        this.audits = this.auditsInOtherScopes
      } else {
        this.audits = await this.reducedAudits(this.$route.params.placeId)
      }
      if (this.audits.length === 0) {
        this.$router.go(-1)
      } else {
        this.$emit('title', this.audits[0].place.name)
      }
    },
    auditCategory: function (currAudit) {
      let category = { name: '', id: '', img: '' }
      if (this.categories.length) {
        this.categories.forEach((topCat) => {
          let subcat = topCat.childs.filter(
            (currCat) => currCat.id === currAudit.checklist.category.id
          )
          if (subcat.length) {
            category = subcat[0]
          }
        })
      }
      return category
    },
    isTopCategoryVacant(subCategoryId) {
      const categories = this.categories.filter((topCat) => {
        return (
          topCat.hasOwnProperty('base-category') &&
          topCat['base-category']?.id === '1'
        )
      })
      if (categories.length === 0) return false
      for (let i = 0; i < categories.length; i++) {
        const topCat = categories[i]
        const subCat = topCat.childs.find((subCat) => {
          return subCat.id === subCategoryId
        })
        if (subCat) {
          return true
        }
      }
      return false
    },
    openAudit(audit) {
      let url = `/zones/${audit.place.zone.id}/places/${
        audit.place.id
      }/audits/${audit.id}?tab=${
        this.$route.query.tab ? this.$route.query.tab : 'myScope'
      }`

      const isTopCategoryVacant = this.isTopCategoryVacant(
        audit.checklist.category.id
      )

      const isVacant =
        isTopCategoryVacant ||
        (audit.checklist.category.hasOwnProperty('base-category') &&
          audit.checklist.category['base-category']?.id === '1')

      if (isVacant) {
        url = `${url}&vacant=true`
      }
      this.$router.push(url)
      if (this.$route.query.tab === 'other') {
        this.$emit('title', audit.checklist.name)
      }
    }
  }
}
</script>
